<template>
    <div>
        <b-row>
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <b-card class="sa-card sa-card-border" header="Assetto Psicopatologico All'Ingresso" header-tag="header" footer-tag="footer" title="">
                    <b-row>
                        <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                            <span v-if="isReadOnly">{{ jsonDataAssettoPsicopatologicoIngresso.voce }}</span>
                            <b-form-textarea v-else v-model="jsonDataAssettoPsicopatologicoIngresso.voce" :readonly="isReadOnly" max-rows="10" rows="8"> </b-form-textarea>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>
<script>
import UtilityMixin from "../../../utility/UtilityMixin";

export default {
    props: {
        isReadOnly: {
            type: Boolean,
            default: false,
        },
        idAccettazione: {
            type: String,
        },
        jsonDataAssettoPsicopatologicoIngresso: {
            type: Object,
            default: function () {
                return {
                    id: null,
                    idAccettazione: this.idAccettazione,
                    voce: "",
                };
            },
        },
    },
    mixins: [UtilityMixin],
    watch: {
        jsonDataAssettoPsicopatologicoIngresso: {
            handler(jsonData) {
                this.$emit("update", jsonData);
            },
            deep: true,
        },
    },
    data() {
        return {
            pathResourceSchedaRelazioneSanitariaAssettoPsicopatologicoIngresso: "/rsaschedarelazionesanitariaassettopsicopatologicoingresso",
        };
    },
    methods: {
        loadSchedaRelazioneSanitariaAssettoPsicopatologicoIngresso() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourceSchedaRelazioneSanitariaAssettoPsicopatologicoIngresso + "/accettazione/" + me.idAccettazione, {}, me.resultResponseSchedaRelazioneSanitariaAssettoPsicopatologicoIngressoSuccess, me.resultResponseSchedaRelazioneSanitariaAssettoPsicopatologicoIngressoError);
        },

        resultResponseSchedaRelazioneSanitariaAssettoPsicopatologicoIngressoSuccess(response) {
            let me = this;
            me.jsonDataAssettoPsicopatologicoIngresso = response.data.data;
        },

        resultResponseSchedaRelazioneSanitariaAssettoPsicopatologicoIngressoError(error) {
            let me = this;
            if (error.response && error.response.status === 404) {
                me.resetForm();
            }
        },

        resetForm() {
            let me = this;
            me.jsonDataAssettoPsicopatologicoIngresso = {
                id: null,
                idAccettazione: me.idAccettazione,
                voce: null,
            };
        },

        onAssettoPsicopatologicoIngresso() {
            let me = this;
            me.jsonDataAssettoPsicopatologicoIngresso.idAccettazione = me.idAccettazione;
            if (!me.jsonDataAssettoPsicopatologicoIngresso.idAccettazione) {
                me.$bvToast.toast("Errore: ID Accettazione mancante", {
                    title: "Errore",
                    variant: "danger",
                    solid: true,
                });
                return;
            }
            UtilityMixin.methods.saveResource(me.pathResourceSchedaRelazioneSanitariaAssettoPsicopatologicoIngresso, me.jsonDataAssettoPsicopatologicoIngresso, me.saveSchedaRelazioneSanitariaAssettoPsicopatologicoIngressoSuccessResponse, me.saveSchedaRelazioneSanitariaAssettoPsicopatologicoIngressoErrorResponse);
        },
        saveSchedaRelazioneSanitariaAssettoPsicopatologicoIngressoSuccessResponse() {},
        saveSchedaRelazioneSanitariaAssettoPsicopatologicoIngressoErrorResponse() {
            console.error("Errore nel salvataggio anamnesi psicopatologico ingresso:");
        },
    },
};
</script>
